import PageHeader from "../../Components/BaseComponents/pageHeader";

export default function Xml() {  
  return (
    <PageHeader topHeader='XML' subHeader='Overview'/>
  );
}